export class CanserModel{
  cancerID ='' ;
   cancerName ='';
   notes= '';
    userId ='';
  modifiedDate ='';

}
